import { RootState } from 'src/config/rootStore';
import { MessageResourcesState } from '../rematchModels/messaging';

export const getMessageResources = (state: RootState): MessageResourcesState => state.messaging;
